import React from 'react';
import { useListContext } from 'react-admin';
// eslint-disable-next-line import/no-extraneous-dependencies
import { RecordContextProvider } from 'ra-core';

const FirstListRecord = (props) => {
	const { children } = props;
	const { data } = useListContext();
	if (!data || data.length === 0) { return null; }
	return (
		<RecordContextProvider value={data[0]}>
			{children}
		</RecordContextProvider>
	);
};

export default FirstListRecord;
